import Slider from "./Slider";
import DitecEffectController from "./DitecEffectController";

class DitecTabSliderController
{

    /**
     * DitecTabSliderController constructor
     *
     * @param {bool} debug
     */
    constructor(debug=false)
    {
        if (!document.querySelector('main'))
            return;
        this.effectController = new DitecEffectController();
        this.init(document.querySelector('main'));
    }

    /**
     * Initialise all tab sliders within specified container
     *
     * @param {HTMLElement} container
     * @param {function|null} callback
     */
    init(container, callback=null)
    {
        const tabSliders = container.querySelectorAll('.tabslider .slider');

        if (!tabSliders) {
            return;
        }

        //const autoplayInterval = 30000;

        for (const tabSlider of tabSliders) {

            //let initialSlide = true;

            new Slider(tabSlider, {
                debug: false,
                //debug: 'tabslider-179',
                autoHeight: true,
                //autoplay: true,
                autoplay: false,
                //autoplayInterval: autoplayInterval,
                slideMode: Slider.SLIDE_MODE_ROTATE,
                gestures: false,
                gesturesWithMouse: false,
                navigation: true,
                controls: true
            });

            const header = tabSlider.querySelector('.tabslider__header-and-nav header *:first-child');
            if (20 < header.textContent.trim().length) {
                tabSlider.classList.add('-has-long-header');
            }

            const slides = tabSlider.querySelectorAll('.slider__item');
            if (1 === slides.length && window.innerWidth >= 1024) tabSlider.classList.add('-has-no-navigation');

            //let tabSliderInterval;
            //let tabSliderProgress = 0;
            //tabSlider.style.setProperty('--autoplay-interval', `${autoplayInterval}ms`);

            tabSlider.addEventListener('slide', (e) => {
                const currentIndex = e.detail.currentIndex;
                const currentItem = e.detail.items[currentIndex];
                if (
                    currentItem.classList.contains('tabslider__item--backgroundMedia') ||
                    currentItem.classList.contains('tabslider__item--backgroundBlack')
                ) {
                    tabSlider.classList.add('-background-is-dark');
                }
                else {
                    tabSlider.classList.remove('-background-is-dark');
                }
                // if (window.innerWidth < 1024 && !initialSlide) {
                //     tabSlider.scrollIntoView();
                // }
                // if (initialSlide)
                //     setTimeout(() => {
                //         initialSlide = false;
                //     }, 2500);
            });

        }

        this.effectController.update();

        if (null !== callback && 'function' === typeof callback) callback(tabSliders);
    }

}

export default DitecTabSliderController;